import { MoreHorizontal, UserCog } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { FilterBar } from "@/components/shared/FilterBar";
import { StatusBadge } from "@/components/shared/StatusBadge";
import { Button } from "@/components/ui/button";
import { tenants } from "@/data/mockData";

export default function Tenants() {
  return (
    <div className="space-y-6">
      <PageHeader title="Tenants" description="All business workspaces on the platform." />
      <FilterBar searchPlaceholder="Search tenants..." />

      <div className="overflow-hidden rounded-lg border border-border bg-card">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs uppercase tracking-wide text-muted-foreground">
            <tr>
              <th className="px-4 py-3 text-left font-medium">Company</th>
              <th className="px-4 py-3 text-left font-medium">Status</th>
              <th className="px-4 py-3 text-left font-medium">Plan</th>
              <th className="px-4 py-3 text-right font-medium">Balance</th>
              <th className="px-4 py-3 text-center font-medium">Channels</th>
              <th className="px-4 py-3 text-left font-medium">Last activity</th>
              <th className="w-32 px-4 py-3"></th>
              <th className="w-10" />
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {tenants.map((t) => (
              <tr key={t.id} className="hover:bg-muted/40">
                <td className="px-4 py-3">
                  <div className="font-medium">{t.company}</div>
                  <div className="font-mono text-xs text-muted-foreground">{t.id}</div>
                </td>
                <td className="px-4 py-3"><StatusBadge status={t.status} /></td>
                <td className="px-4 py-3 text-xs">{t.plan}</td>
                <td className="px-4 py-3 text-right">${t.balance.toLocaleString()}</td>
                <td className="px-4 py-3 text-center">{t.channels}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{t.lastActivity}</td>
                <td className="px-4 py-3"><Button variant="outline" size="sm"><UserCog className="h-3.5 w-3.5" />Impersonate</Button></td>
                <td className="px-2 py-3"><Button variant="ghost" size="icon"><MoreHorizontal className="h-4 w-4" /></Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
